module.exports = __webpack_public_path__ + "static/img/建筑智能化_中央空调系统2@2x.5314df2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download1/建筑智能化_中央空调系统2@2x.png
// module id = 4NlX
// module chunks = 1